jQuery(document).ready(function($){
	$('#beachesContent').slick({
		slide: '.beach',
		infinite: true,
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: '.prev-arrow',
		nextArrow: '.next-arrow',
		asNavFor: '#beachImages',
		fade: true
	});
	$('#beachImages').slick({
		infinite: true,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true
	});
	// $('.featureContainer').slick({
	// 	slide: '.featureInner',
	// 	infinite: true,
	// 	arrows: false,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	asNavFor: '#featureImages',
	// 	fade: true,
	// 	autoplay: true,
	// 	autoplaySpeed: 5000,
	// 	draggable: false,
	// 	pauseOnFocus: false,
	// 	pauseOnHover: false
	// });
	// $('#featureImages').slick({
	// 	infinite: true,
	// 	arrows: false,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	fade: true,
	// 	draggable: false
	// });

	$(document).on('open.zf.reveal', '[data-reveal]', function () {
		// Image Gallery
		setTimeout(function(){
			$('.gallery-images').slick({
				slide: '.image',
				infinite: true,
				arrows: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				draggable: false,
				pauseOnFocus: false,
				pauseOnHover: false,
				prevArrow: '.prev-arrow',
				nextArrow: '.next-arrow',
			});
		}, 1);
	});
	$(document).on('closed.zf.reveal', '[data-reveal]', function () {
		// Image Gallery
		setTimeout(function(){
			$('.gallery-images').slick('unslick');
			$('.gallery-thumbs').slick('unslick');
		}, 1);
	});

	$(document).on( 'click', '#mobileToggle', function() {
		$(this).toggleClass('active');
		$(this).parent('.titleHolder').toggleClass('active');
		$('.menuHolder').slideToggle();
	});

	$(document).on( 'click', '#sidenav .widgettitle', function() {
		$(this).toggleClass('active');
		$(this).next('ul').slideToggle();
	});

	$(document).on( 'click', '#sidebar .opensub', function() {
		$(this).toggleClass('active');
		$('#sidebar #sidenav').slideToggle();
	});

	$(document).on( 'click', '#explore-map #mapFilterToggle', function() {
		$(this).toggleClass('active');
		$('#wpgmza_filter_1 .wpgmza_cat_ul.wpgmza_cat_checkbox_item_holder').slideToggle();
	});

	$(window).scroll(function() {    
		// find the id with class 'active' and remove it
		var scroll = $(window).scrollTop();
		// add the 'active' class to the correct id based on the scroll amount
		if (scroll <= 500) {
			$("#hover_booking_button").removeClass("stuck");
		} else if (scroll >= 501) {
			$("#hover_booking_button").addClass("stuck");
		}
	});
	

	// Homepage Ad Grid
	function infoHeight() {
		$('body.home #ad-grid .bottomInfo').each(function() {
			var titleHeight = $(this).find('.titleHolder').height();
			titleHeight = titleHeight + 40;
			$(this).find('.infoHolder').css('transform', 'translateY(-'+titleHeight+'px)');
			$(this).on('mouseenter', function() {
				$(this).find('.infoHolder').css('transform', 'translateY(-100%)');
			});
			$(this).on('mouseleave', function() {
				$(this).find('.infoHolder').css('transform', 'translateY(-'+titleHeight+'px)');
			});
		});
		$('.bsaProListingCategoryCallout').each(function() {
			var titleHeight = $(this).find('.titleHolder').height();
			titleHeight = titleHeight + 40;
			$(this).find('.infoHolder').css('transform', 'translateY(-'+titleHeight+'px)');
			$(this).on('mouseenter', function() {
				$(this).find('.infoHolder').css('transform', 'translateY(-100%)');
			});
			$(this).on('mouseleave', function() {
				$(this).find('.infoHolder').css('transform', 'translateY(-'+titleHeight+'px)');
			});
		});
	}
	infoHeight();

	$( window ).resize(function() {
		infoHeight();
	});

});